import React from "react";
import { useTranslation } from "react-i18next";

import { OnboardingSteps } from "../../utils/constants";
import HowMuchWouldYouLikeToMake from "../onboarding/HowMuchWouldYouLikeToMake/HowMuchWouldYouLikeToMake";
import SetStreakGoal from "../onboarding/SetStreakGoal/SetStreakGoal";
import ReferralCodePage from "../onboarding/ReferralCodePage/ReferralCodePage";
import CreateUserNamePage from "../onboarding/CreateUserNamePage/CreateUserNamePage";
import SignUpPage from "../onboarding/SignUpPage/SignUpPage";
import SignUpSuccessfulPage from "../onboarding/SignUpSuccessfulPage/SignUpSuccessfulPage";
import SettingEarningsGoal from "../onboarding/SettingEarningsGoal/SettingEarningsGoal";
import useOnboardingSteps from "../../hooks/useOnboardingSteps";
import { renderHeaders } from "../../utils/renderHeaders";

function SignUpStartFlowPage() {
  const { currentStep } = useOnboardingSteps();
  const { t } = useTranslation();
  let contentEl: JSX.Element;

  switch (currentStep) {
    case OnboardingSteps.SIGN_UP_SUCCESSFUL:
      contentEl = <SignUpSuccessfulPage />;
      break;
    case OnboardingSteps.SET_EARNINGS_GOALS:
      contentEl = <HowMuchWouldYouLikeToMake />;
      break;
    case OnboardingSteps.SET_STREAK_GOAL:
      contentEl = <SetStreakGoal />;
      break;
    case OnboardingSteps.SETTING_EARNINGS_GOALS:
      contentEl = <SettingEarningsGoal />;
      break;
    case OnboardingSteps.SIGN_UP:
      contentEl = <SignUpPage />;
      break;
    case OnboardingSteps.USE_REFERRAL_CODE:
      contentEl = <ReferralCodePage />;
      break;
    case OnboardingSteps.CLAIM_USERNAME:
      contentEl = <CreateUserNamePage />;
      break;
    default:
      contentEl = <HowMuchWouldYouLikeToMake />;
  }

  return (
    <>
      {renderHeaders({
        title: t("metadata:sign_up_for_free_hyper_gaming_app"),
        description: t("metadata:sign_up_seo_description"),
        ogTitle: t("metadata:win_cash_in_1v1_and_multiplayer_games"),
      })}
      {contentEl}
    </>
  );
}

export default SignUpStartFlowPage;
